import { render, staticRenderFns } from "./CardCatalogueSection.vue?vue&type=template&id=c5351726&scoped=true"
import script from "./CardCatalogueSection.vue?vue&type=script&lang=js"
export * from "./CardCatalogueSection.vue?vue&type=script&lang=js"
import style0 from "./CardCatalogueSection.vue?vue&type=style&index=0&id=c5351726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5351726",
  null
  
)

export default component.exports